export default "__VITE_ASSET__CKreoQ1h__"